export default "__VITE_ASSET__c5b40cd9__"